// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0
var validateUrlUnicodeSubDomainSegment = /(?:(?:[a-z0-9]|[^\u0000-\u007f])(?:(?:[a-z0-9_\-]|[^\u0000-\u007f])*(?:[a-z0-9]|[^\u0000-\u007f]))?)/i;
export default validateUrlUnicodeSubDomainSegment;


//////////////////
// WEBPACK FOOTER
// ./node_modules/twitter-text/dist/esm/regexp/validateUrlUnicodeSubDomainSegment.js
// module id = 437
// module chunks = 110